"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentType = void 0;
var AttachmentType;
(function (AttachmentType) {
    AttachmentType["CASE_LABELS"] = "CASE_LABELS";
    AttachmentType["SHIPPING_LABELS"] = "SHIPPING_LABELS";
    AttachmentType["CASE_SSCC_LABELS"] = "CASE_SSCC_LABELS";
    AttachmentType["PALLET_LABELS"] = "PALLET_LABELS";
    AttachmentType["BOL"] = "BOL";
    AttachmentType["VENDOR_GUIDELINES"] = "VENDOR_GUIDELINES";
    AttachmentType["PACKING_SLIP"] = "PACKING_SLIP";
    AttachmentType["SIGNED_BOL"] = "SIGNED_BOL";
    AttachmentType["PACKING_LIST"] = "PACKING_LIST";
    AttachmentType["COMMERCIAL_INVOICE"] = "COMMERCIAL_INVOICE";
    AttachmentType["PREP_INSTRUCTIONS"] = "PREP_INSTRUCTIONS";
    AttachmentType["ASN_856"] = "ASN_856";
    AttachmentType["PO_850"] = "PO_850";
})(AttachmentType || (exports.AttachmentType = AttachmentType = {}));
//# sourceMappingURL=AttachmentType.js.map